import React from 'react'

import { Button, Tooltip} from '@material-ui/core';
import { Dialog } from '../Interface/Dialog'

const buttonStyles = {
  margin: '30px 0 -4px auto', 
  display: 'block', 
  lineHeight: '1em',
  width: 'auto'
}

// Wrapper for individual component in a SortableList
// Keeps the sorting functionality out of the components themselves
export class ListItem extends React.Component {
  
  // keeps track of its own id to help it know when to rerender
  state = {
    listId: this.props.listId ? this.props.listId : null,
  }

  removeItem = () => this.props.removeItem(this.props.index)
  
  render() {
    const { disableDelete,index,given,label,path } = this.props;

    const DisabledDeleteBtn = <Tooltip title={`Unable to delete. You have reached the min number that is required.`}>
                                <span style={buttonStyles}>
                                  <Button 
                                    disabled
                                    onClick={this.removeItem} 
                                    variant="text"
                                    color="primary"
                                    style={{padding: 0, lineHeight: 'inherit'}}
                                  >
                                    Delete {label}&nbsp;&nbsp;<i className="far fa-trash-alt"></i>
                                  </Button>
                                </span>
                              </Tooltip>

    const DeleteDialog = <Dialog 
                            openButtonProps={{
                              variant:"text",
                              color:"primary",
                              style: {...buttonStyles, padding: 0},
                            }}
                            openButtonLabel={<span>Delete {label}&nbsp;&nbsp;<i className="far fa-trash-alt"></i></span>}
                            primaryText={`Are you sure you want to delete this ${label.toLowerCase()}?`}
                            actionButton={{
                              warning: true,
                              label: "Delete",
                              action: this.removeItem,
                            }}
                          />
    
    return (
      <div data-list-id={this.props.listId}>
        {React.cloneElement(this.props.children, { 
          given,
          path,
          index,
          deleteBtn: disableDelete ? DisabledDeleteBtn : DeleteDialog
        })}

      </div>
    )
  }
}